import PropTypes from "prop-types";

const AlertError = ({ mensaje }) => {
  return <p className="alert alert-danger p2 mt-4 text-center">{mensaje}</p>;
};

AlertError.prototype = {
  mensaje: PropTypes.string,
};

export default AlertError;
